<div class="slideshow-header-controls">
  <button mat-icon-button class="control-btn" (click)="onPrevious()">
    <mat-icon>skip_previous</mat-icon>
  </button>

  <button mat-icon-button class="control-btn play-pause-btn" (click)="togglePause()">
    <mat-icon>{{ isPaused() ? 'play_arrow' : 'pause' }}</mat-icon>
  </button>

  <button mat-icon-button class="control-btn" (click)="onNext()">
    <mat-icon>skip_next</mat-icon>
  </button>
</div>
